import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { productFruits, ProductFruitsUserObject } from 'product-fruits';

@Injectable({ providedIn: 'root' })
export class ProductFruitsService {
  private initialized: Promise<void> | null = null;
  public readonly productFruitsReady = new BehaviorSubject<boolean>(false);

  async inititialize(workspaceCode: string, language: string, userObject: ProductFruitsUserObject): Promise<void> {
    if (this.initialized === null) {
      this.initialized = new Promise<void>(resolve => {
        window.addEventListener('productfruits_ready', () => {
          console.info('ProductFruits is ready');
          this.productFruitsReady.next(true);
          resolve();
        }, {
          once: true
        });

        productFruits.init(workspaceCode, language, userObject);
      });
    }
    return this.initialized;
  }

  async triggerEvent(eventName: string): Promise<boolean> {
    if (!this.productFruitsReady.value) {
      return false;
    }

    try {
      await window.productFruits?.api?.events?.track(eventName, { forwardToIntegrations: true });
      return true;
    } catch {
      return false;
    }
  }

  identifyUser(userObject: ProductFruitsUserObject) {
    this.productFruitsReady.pipe(
      filter(isReady => isReady),
      take(1)
    ).subscribe(() => {
      window.productFruits?.identifyUser?.(userObject);
    });
  }

  destroy() {
    if (this.initialized !== null) {
      this.initialized = null;
      this.productFruitsReady.next(false);
      // Fully remove PF (recommended on SPA logout or language switch)
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      (window.productFruits as any)?.services?.destroy();
    }
  }
}
